module.exports = __webpack_public_path__ + "static/img/standard-card.2f8d0ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/cards/standard-card.png
// module id = JvGq
// module chunks = 27